import { Button, Form, Input, message, Popconfirm } from "antd";
import React, { useState } from "react";
import { PiPlus, PiSelectionSlash } from "react-icons/pi";
import { addNewCategory } from "../action";

type Props = {
  onCategoryAdded?: () => void;
};

interface FormData {
  title: string;
}
const AddNewCategory = (props: Props) => {
  const { onCategoryAdded } = props;
  const [form] = Form.useForm<FormData>();
  const [loading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (values: FormData) => {
    setIsLoading(true);
    try {
      const result = await addNewCategory(values.title);
      if (result) {
        message.success("Category added successfully!");
        form.resetFields();
        if (onCategoryAdded) {
          onCategoryAdded();
        }
      } else {
        message.error("Failed to add category. Please try again.");
      }
    } catch (err) {
      message.error("Failed to add category. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Form form={form} onFinish={handleSubmit} className="flex flex-row gap-2">
      <Form.Item name="title">
        <Input placeholder="Category title ..." />
      </Form.Item>
      <Popconfirm
        title="Add Category"
        description="Are you sure you want to add this category?"
        onConfirm={() => form.submit()}
        okText="Yes"
        cancelText="No"
      >
        <Button type="primary" icon={<PiPlus />} loading={loading} />
      </Popconfirm>
    </Form>
  );
};

export default AddNewCategory;
